import React from 'react';
import './App.css';

function App() {
  const handleDownload = () => {
    // Трекинг Lead события в Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
    
    // Создаем ссылку для скачивания файла
    const link = document.createElement('a');
    link.href = '/app.apk'; // путь к файлу в папке public
    link.download = 'Tanishuv.apk'; // имя файла при скачивании
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="App">
      <div className="background-image"></div>
      <div className="card">
        <div className="heart-icon">
          <img src="/logo.jpg" alt="Logo" />
        </div>
        
        <h1 className="title">Olove</h1>
        <p className="subtitle">Faqat Tanishuv ilovamizda tanishing va seving</p>
        
        <div className="online-status">
          <span className="green-dot"></span>
          <span className="online-text">2,847 kеsiz onlayn</span>
        </div>
        
        <div className="stats">
          <div className="stat-item">
            <div className="stat-value">50K+</div>
            <div className="stat-label">Yuklаb oldi</div>
          </div>
          
          <div className="stat-divider"></div>
          
          <div className="stat-item">
            <div className="stat-value">
              <span className="stars">★★★★★</span>
            </div>
            <div className="stat-label">RЕYTING</div>
          </div>
          
          <div className="stat-divider"></div>
          
          <div className="stat-item">
            <div className="stat-value">100%</div>
            <div className="stat-label">BEPUL</div>
          </div>
        </div>
        
        <button className="download-button" onClick={handleDownload}>
          O'rnatish
        </button>
        
        <div className="app-info">
          <p>Android uchun · 52 MB · Reklama yo'q</p>
        </div>
        
        <div className="security-note">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="rgba(255,255,255,0.5)">
            <path d="M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3z"/>
          </svg>
          <span>Shikaiziy nartumlash himoyalangan</span>
        </div>
      </div>
    </div>
  );
}

export default App;
